import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { formatCurrency } from 'src/shared/utils/format-currency'

const PLACEHOLDER_IMG =
  'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?cs=srgb&dl=pexels-binyaminmellish-1396122.jpg&fm=jpg'

type ListingProps = {
  username: string
  price: number
  beds: number
  baths: number
  sqft: number
  address: string
  listedDate: string
  listingNumber: number
}

const Listing = ({ username, price, beds, baths, sqft, address, listedDate, listingNumber }: ListingProps) => {
  const navigate = useNavigate()

  return (
    <div
      className="relative cursor-pointer bg-white"
      onClick={() => navigate(paths.users.publicProfile.singleListing.getHref(username, listingNumber.toString()))}
    >
      <img src={PLACEHOLDER_IMG} alt="image of listing" className="h-[165px] w-full rounded-[8px] object-cover" />
      <div className="flex flex-col gap-1 py-3">
        <div className="line-clamp-1 text-[22px] font-bold">${formatCurrency(price)}</div>
        <div className="line-clamp-1 text-sm leading-tight text-primary">
          {beds} beds • {baths} baths • {sqft} sqft
        </div>
        <div className="line-clamp-1 text-sm font-semibold leading-tight text-muted">{address}</div>
        <div className="line-clamp-1 text-sm leading-tight text-muted">Listed {listedDate}</div>
      </div>
      <div className="absolute left-3 top-3">
        <p
          className="rounded-[5px] px-2 py-1 text-xs font-semibold text-white"
          style={{
            background: 'rgba(27, 48, 41, 0.75)',
            backdropFilter: 'blur(1px)',
          }}
        >
          #{listingNumber}
        </p>
      </div>
    </div>
  )
}

export default Listing
